import styled from "styled-components";

import colors from "../../assets/css/colors";

export const SuportButton = styled.div`
    width: 87px;
    height: 55px;
    padding-top: 7px;
    border-radius: 5px;
    background-color: #FFCAAE82;
    vertical-align: center;
    text-align: center;

    cursor: pointer;
`

export const ContainerAccordion = styled.div`
  margin-top: 33px;
`

export const FaqImg = styled.img`
  width: 101px;
  height: 110px;
`

export const Img = styled.img``

export const Logo100pay = styled.img`
  height: 20px;
`

export const Box = styled.div``

export const SuportText = styled.p`
    font-size: 8px;
    color: #F58B1E;
    text-align: center;
`

export const CardCustom = styled.div`

  max-width: 500px;
  height: auto;
  /* width: 90%; */
  border-radius: 42px;
  display: block;
  overflow: auto;

  padding: 32px;
  margin-top: 1vh;
  margin-bottom: 1vh;

  background-color: #fff;
  -webkit-box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
  -moz-box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
  box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
`;

export const Title = styled.h2`
  font: normal normal normal 17px/23px Circular Std Book;
  color: #F58B1E;
  margin: 0px;
`

export const DivContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const ModalTitle = styled.h1`
  text-align: center;
  font: normal normal normal 32px Circular Std Book;
  color: #F58B1E;
  margin-bottom: 0px;
`;

export const Close = styled.button`
    width: 30px;
    height: 30px;
    padding: 0px;
    border: none;
    outline: none;
    background-color: ${colors.white};
    margin-bottom: 48px;

    &:focus{
        outline: none;
    }
`;

export const ExampleChatTitle = styled.span`
  font: normal normal 300 11px Muli;
  color: #B8B4CC;
  margin-top: 5px;
  margin-bottom: 60px;
  
`